import { SvgIcon } from './svg-icon';
import { ComponentSvgIconProps, SvgIconProps } from './svg-icon.d';
import { mergeProps } from 'solid-js';

const defaultProps: SvgIconProps = {
    viewBox: '0 0 20 20',
    // fill: currentColor → icon inherits the parent's computed `color` property
    // (e.g., button text color, link hover color). Consumers can override by
    // passing `fill` prop explicitly.
    fill: 'currentColor',
    defaultAriaLabel: 'Arrow Right Icon',
};

export const ArrowRightIcon = (componentProps: ComponentSvgIconProps) => {
    const props = mergeProps(defaultProps, componentProps);

    return (
        <SvgIcon {...props}>
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M14.4657 9.18576L10.1372 4.85737C9.81923 4.53937 9.81923 4.0238 10.1372 3.70579C10.4552 3.3878 10.9708 3.38779 11.2888 3.70579L17.0073 9.42418C17.16 9.57689 17.2458 9.78401 17.2458 9.99997C17.2458 10.2159 17.16 10.423 17.0073 10.5758L11.2888 16.2942C10.9708 16.6122 10.4552 16.6122 10.1372 16.2942C9.81923 15.9762 9.81923 15.4606 10.1372 15.1426L14.4655 10.8143H3.57428C3.12457 10.8143 2.76 10.4498 2.76 10.0001C2.76 9.55033 3.12457 9.18576 3.57428 9.18576H14.4657Z"
            />
        </SvgIcon>
    );
};
